import React from 'react';
import './Spinner.css';

export interface WxbSpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: number;
  tip?: string;
}

export const WxbSpinner: React.FC<WxbSpinnerProps> = ({
  size = 32,
  tip,
  className = '',
  'aria-label': ariaLabel = tip || '加载中',
  ...props
}) => (
  <div
    {...props}
    className={`wxb-spinner ${className}`}
    role="status"
    aria-live="polite"
    aria-label={ariaLabel}
  >
    <svg
      className="wxb-spinner-svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="20" cy="20" r="16" fill="none" stroke="var(--wx-surface-3)" strokeWidth="3" />
      <circle
        cx="20"
        cy="20"
        r="16"
        fill="none"
        stroke="var(--wx-blue-700)"
        strokeWidth="3"
        strokeDasharray="80 20"
        strokeLinecap="round"
        className="wxb-spinner-arc"
      />
    </svg>
    {tip && <span className="wxb-spinner-tip">{tip}</span>}
  </div>
);
